// src/components/Toast.js
import React, { useEffect, useState } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'success', duration = 7000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true); // Start as visible

  useEffect(() => {
    console.log('🎉 Toast component mounted!');
    console.log('Message:', message);
    console.log('Type:', type);
    console.log('Duration:', duration);
    
    // Auto-hide after duration
    const hideTimer = setTimeout(() => {
      console.log('Toast auto-hiding');
      setIsVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => {
      clearTimeout(hideTimer);
    };
  }, [duration, onClose, message]);

  const handleClose = () => {
    console.log('Toast manually closed');
    setIsVisible(false);
    if (onClose) onClose();
  };

  console.log('Toast render - isVisible:', isVisible);

  if (!isVisible) return null;

  return (
    <div className="toast-container toast-show" style={{ display: 'block' }}>
      <div className={`toast toast-${type}`}>
        <div className="toast-content">
          {message}
        </div>
        <button 
          className="toast-close" 
          onClick={handleClose}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;
